import { render, staticRenderFns } from "./xhmDetail.vue?vue&type=template&id=cb01ac46&"
import script from "./xhmDetail.vue?vue&type=script&lang=js&"
export * from "./xhmDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports